var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alert", class: _vm.type }, [
    _vm.type === "success"
      ? _c(
          "svg",
          {
            staticClass: "alert-icon",
            attrs: {
              width: "38",
              height: "38",
              viewBox: "0 0 38 38",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("g", { attrs: { filter: "url(#filter0_d_8405_39965)" } }, [
              _c("circle", {
                attrs: { cx: "19", cy: "15", r: "15", fill: "#191A1C" }
              })
            ]),
            _vm._v(" "),
            _c("g", { attrs: { filter: "url(#filter1_d_8405_39965)" } }, [
              _c("path", {
                attrs: { d: "M24.5556 11L16.6111 19L13 15.3636", fill: "black" }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M24.5556 11L16.6111 19L13 15.3636",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              })
            ]),
            _vm._v(" "),
            _c("defs", [
              _c(
                "filter",
                {
                  attrs: {
                    id: "filter0_d_8405_39965",
                    x: "0",
                    y: "0",
                    width: "38",
                    height: "38",
                    filterUnits: "userSpaceOnUse",
                    "color-interpolation-filters": "sRGB"
                  }
                },
                [
                  _c("feFlood", {
                    attrs: {
                      "flood-opacity": "0",
                      result: "BackgroundImageFix"
                    }
                  }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      in: "SourceAlpha",
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                      result: "hardAlpha"
                    }
                  }),
                  _vm._v(" "),
                  _c("feOffset", { attrs: { dy: "4" } }),
                  _vm._v(" "),
                  _c("feGaussianBlur", { attrs: { stdDeviation: "2" } }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                    }
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in2: "BackgroundImageFix",
                      result: "effect1_dropShadow_8405_39965"
                    }
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in: "SourceGraphic",
                      in2: "effect1_dropShadow_8405_39965",
                      result: "shape"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "filter",
                {
                  attrs: {
                    id: "filter1_d_8405_39965",
                    x: "8",
                    y: "10",
                    width: "21.5547",
                    height: "18",
                    filterUnits: "userSpaceOnUse",
                    "color-interpolation-filters": "sRGB"
                  }
                },
                [
                  _c("feFlood", {
                    attrs: {
                      "flood-opacity": "0",
                      result: "BackgroundImageFix"
                    }
                  }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      in: "SourceAlpha",
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                      result: "hardAlpha"
                    }
                  }),
                  _vm._v(" "),
                  _c("feOffset", { attrs: { dy: "4" } }),
                  _vm._v(" "),
                  _c("feGaussianBlur", { attrs: { stdDeviation: "2" } }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                    }
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in2: "BackgroundImageFix",
                      result: "effect1_dropShadow_8405_39965"
                    }
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in: "SourceGraphic",
                      in2: "effect1_dropShadow_8405_39965",
                      result: "shape"
                    }
                  })
                ],
                1
              )
            ])
          ]
        )
      : _c(
          "svg",
          {
            staticClass: "alert-icon",
            attrs: {
              width: "38",
              height: "38",
              viewBox: "0 0 38 38",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("g", { attrs: { filter: "url(#filter0_d_8405_40004)" } }, [
              _c("circle", {
                attrs: { cx: "19", cy: "15", r: "15", fill: "#191A1C" }
              })
            ]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M19 8L19 16.2979",
                stroke: "white",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "19", cy: "21.0625", r: "2", fill: "white" }
            }),
            _vm._v(" "),
            _c("defs", [
              _c(
                "filter",
                {
                  attrs: {
                    id: "filter0_d_8405_40004",
                    x: "0",
                    y: "0",
                    width: "38",
                    height: "38",
                    filterUnits: "userSpaceOnUse",
                    "color-interpolation-filters": "sRGB"
                  }
                },
                [
                  _c("feFlood", {
                    attrs: {
                      "flood-opacity": "0",
                      result: "BackgroundImageFix"
                    }
                  }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      in: "SourceAlpha",
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                      result: "hardAlpha"
                    }
                  }),
                  _vm._v(" "),
                  _c("feOffset", { attrs: { dy: "4" } }),
                  _vm._v(" "),
                  _c("feGaussianBlur", { attrs: { stdDeviation: "2" } }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                    }
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in2: "BackgroundImageFix",
                      result: "effect1_dropShadow_8405_40004"
                    }
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in: "SourceGraphic",
                      in2: "effect1_dropShadow_8405_40004",
                      result: "shape"
                    }
                  })
                ],
                1
              )
            ])
          ]
        ),
    _vm._v(" "),
    _c("span", { staticClass: "alert-text" }, [_vm._v(_vm._s(_vm.text))]),
    _vm._v(" "),
    _c(
      "button",
      { staticClass: "alert-close", on: { click: _vm.alertClose } },
      [
        _c(
          "svg",
          {
            staticClass: "close-icon",
            attrs: {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("g", { attrs: { filter: "url(#filter0_d_8405_39980)" } }, [
              _c("path", {
                attrs: {
                  d: "M5 1L14.9998 10.9998",
                  stroke: "#191A1C",
                  "stroke-width": "2",
                  "stroke-linecap": "round"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M15 1L5.00017 10.9998",
                  stroke: "#191A1C",
                  "stroke-width": "2",
                  "stroke-linecap": "round"
                }
              })
            ]),
            _vm._v(" "),
            _c("defs", [
              _c(
                "filter",
                {
                  attrs: {
                    id: "filter0_d_8405_39980",
                    x: "0",
                    y: "0",
                    width: "20",
                    height: "20",
                    filterUnits: "userSpaceOnUse",
                    "color-interpolation-filters": "sRGB"
                  }
                },
                [
                  _c("feFlood", {
                    attrs: {
                      "flood-opacity": "0",
                      result: "BackgroundImageFix"
                    }
                  }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      in: "SourceAlpha",
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                      result: "hardAlpha"
                    }
                  }),
                  _vm._v(" "),
                  _c("feOffset", { attrs: { dy: "4" } }),
                  _vm._v(" "),
                  _c("feGaussianBlur", { attrs: { stdDeviation: "2" } }),
                  _vm._v(" "),
                  _c("feComposite", {
                    attrs: { in2: "hardAlpha", operator: "out" }
                  }),
                  _vm._v(" "),
                  _c("feColorMatrix", {
                    attrs: {
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                    }
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in2: "BackgroundImageFix",
                      result: "effect1_dropShadow_8405_39980"
                    }
                  }),
                  _vm._v(" "),
                  _c("feBlend", {
                    attrs: {
                      mode: "normal",
                      in: "SourceGraphic",
                      in2: "effect1_dropShadow_8405_39980",
                      result: "shape"
                    }
                  })
                ],
                1
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }